import {
    BLOCK_HISTORY,
    // HEARTBEAT, 
    // SEARCH_LOADING,
     UNBLOCK_HISTORY,
     SET_USER,
     USER_IS_LOADING
} from '../actions';
import {LOCATION_CHANGE} from 'connected-react-router';

export function heartbeat (state = {}, action = {}) {
    return state;
}

// export function search (state = {}, action) {
//     switch (action.type) {
//         case SEARCH_LOADING:
//             return action.payload;
//         default:
//             return state;
//     }
// }

export function historyBlocking(state = {}, action = {}) {
    switch(action.type) {
        case LOCATION_CHANGE:
        case UNBLOCK_HISTORY:
            if (state.unblockFunction && typeof state.unblockFunction === 'function') {
                state.unblockFunction();
            }
            return {};
        case BLOCK_HISTORY:
            return {
                unblockFunction: action.payload
            };
        default:
            return state;
    }
}

export function user(state = {}, action = {}){
    return action.type === SET_USER ? action.payload : state;
}

export function userIsLoading(state = true, action = {}){
    return action.type === USER_IS_LOADING ? action.payload : state;
}


// WEBPACK FOOTER //
// ./src/reducers/reducers-app.js